import { render } from "./TestMarking.vue?vue&type=template&id=1fa010e8"
import script from "./TestMarking.vue?vue&type=script&lang=js"
export * from "./TestMarking.vue?vue&type=script&lang=js"

import "./TestMarking.vue?vue&type=style&index=0&id=1fa010e8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__